<template>
  <div class="page-container">
    <div class="reg-config-layout">
      <div class="reg-sidebar">
        <div class="sidebar-add-area">
          <el-button
            v-auth="'business:auditMaterialConfig:save'"
            v-if="!showCountrySelect"
            type="primary"
            size="small"
            icon="el-icon-plus"
            style="width:100%;"
            @click="openAddCountry">添加国家配置</el-button>
          <div v-else class="select-with-close">
            <el-select
              ref="countrySelectRef"
              v-model="addingCountry"
              filterable
              placeholder="搜索国家..."
              size="small"
              style="flex:1;"
              @change="onAddCountrySelect"
              popper-class="country-select-popper">
              <el-option
                v-for="c in availableCountries"
                :key="c.countryCode"
                :label="c.countryCode + ' - ' + (c.countryCname || c.countryName)"
                :value="c.countryCode">
                <span style="float:left;">{{ c.countryCode }}</span>
                <span style="float:right;color:#8492a6;font-size:13px;">{{ c.countryCname || c.countryName }}</span>
              </el-option>
            </el-select>
            <i class="el-icon-close close-select-btn" @click="cancelAddCountry"></i>
          </div>
        </div>
        <div class="country-list">
          <div class="country-item" :class="{active:currentCountry==='DEFAULT'}" @click="switchCountry('DEFAULT')">
            <span class="country-icon">⚙️</span><span>默认配置</span>
          </div>
          <div v-for="c in configuredCountries" :key="c.countryCode" class="country-item" :class="{active:currentCountry===c.countryCode}" @click="switchCountry(c.countryCode)">
            <span class="country-icon">📍</span><span>{{ c.countryCode }} - {{ c.countryCname||c.countryName }}</span>
            <span v-auth="'business:auditMaterialConfig:delete'" class="country-del" @click.stop="deleteCountry(c)" title="删除">×</span>
          </div>
        </div>
      </div>
      <div class="reg-content" v-loading="loading">
        <!-- 身份认证 -->
        <div class="cfg-card">
          <div class="cfg-card-header">
            <span>🆔 身份认证</span>
            <el-switch v-model="form.idAuthEnabled" active-color="var(--brand-primary)"></el-switch>
          </div>
          <div class="cfg-card-body" v-show="form.idAuthEnabled">
            <div class="cfg-row">
              <span class="cfg-label">身份类型</span>
              <div class="cfg-check-group">
                <el-checkbox v-model="form.idTypes[0].enabled">身份证</el-checkbox>
                <el-checkbox v-model="form.idTypes[1].enabled">护照</el-checkbox>
                <el-checkbox v-model="form.idTypes[2].enabled">驾照</el-checkbox>
              </div>
            </div>
            <template v-for="(idType, i) in form.idTypes">
              <div v-if="idType.enabled" :key="idType.type" style="border-top:1px solid #f0f0f0;">
                <div class="cfg-row" style="background:#f8f9fa;padding:10px 20px;font-weight:600;font-size:12px;">
                  {{ ['身份证配置','护照配置','驾照配置'][i] }}
                </div>
                <div class="cfg-row">
                  <span class="cfg-label">OCR识别</span>
                  <el-checkbox v-model="idType.ocrEnabled" @change="idType.ocrServiceId=null">启用OCR识别</el-checkbox>
                </div>
                <div class="cfg-row" v-show="idType.ocrEnabled">
                  <div style="padding-left:136px;flex:1;">
                    <el-select v-model="idType.ocrServiceId" placeholder="请选择OCR服务" clearable size="small" style="width:260px;">
                      <el-option v-for="s in ocrServices" :key="s.id" :label="s.vendor+' - '+s.serviceName" :value="s.id"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="cfg-row">
                  <span class="cfg-label">要素认证</span>
                  <el-checkbox v-model="idType.factorEnabled" @change="idType.factorServiceId=null">启用要素认证</el-checkbox>
                </div>
                <div class="cfg-row" v-show="idType.factorEnabled">
                  <div style="padding-left:136px;flex:1;">
                    <el-select v-model="idType.factorServiceId" placeholder="请选择要素认证服务" clearable size="small" style="width:260px;">
                      <el-option v-for="s in factorServices" :key="s.id" :label="s.vendor+' - '+s.serviceName" :value="s.id"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </template>
            <div class="cfg-row" style="border-top:1px solid #f0f0f0;">
              <span class="cfg-label">认证上限次数</span>
              <el-input-number v-model="form.idAuthMaxAttempts" :min="1" :max="10" size="small" style="width:100px;"></el-input-number>
              <span style="font-size:12px;color:#909399;margin-left:8px;">用户每日最多可尝试认证次数</span>
            </div>
          </div>
        </div>
        <!-- 银行卡认证 -->
        <div class="cfg-card" style="margin-top:16px;">
          <div class="cfg-card-header">
            <span>💳 银行卡认证</span>
            <el-switch v-model="form.bankAuthEnabled" active-color="var(--brand-primary)"></el-switch>
          </div>
          <div class="cfg-card-body" v-show="form.bankAuthEnabled">
            <div class="cfg-row">
              <span class="cfg-label">OCR识别</span>
              <el-checkbox v-model="form.bankAuthOcrEnabled" @change="form.bankAuthOcrServiceId=null">启用OCR识别</el-checkbox>
              <span style="font-size:12px;color:#909399;margin-left:8px;">自动识别银行卡卡号等信息</span>
            </div>
            <div class="cfg-row" v-show="form.bankAuthOcrEnabled">
              <div style="padding-left:136px;flex:1;">
                <el-select v-model="form.bankAuthOcrServiceId" placeholder="请选择OCR服务" clearable size="small" style="width:260px;">
                  <el-option v-for="s in ocrServices" :key="s.id" :label="s.vendor+' - '+s.serviceName" :value="s.id"></el-option>
                </el-select>
              </div>
            </div>
            <div class="cfg-row">
              <span class="cfg-label">要素认证</span>
              <el-checkbox v-model="form.bankAuthFactorEnabled" @change="form.bankAuthFactorServiceId=null">启用要素认证</el-checkbox>
              <span style="font-size:12px;color:#909399;margin-left:8px;">验证银行卡四要素（姓名、身份证、卡号、手机号）</span>
            </div>
            <div class="cfg-row" v-show="form.bankAuthFactorEnabled">
              <div style="padding-left:136px;flex:1;">
                <el-select v-model="form.bankAuthFactorServiceId" placeholder="请选择要素认证服务" clearable size="small" style="width:260px;">
                  <el-option v-for="s in factorServices" :key="s.id" :label="s.vendor+' - '+s.serviceName" :value="s.id"></el-option>
                </el-select>
              </div>
            </div>
            <div class="cfg-row" style="border-top:1px solid #f0f0f0;">
              <span class="cfg-label">认证上限次数</span>
              <el-input-number v-model="form.bankAuthMaxAttempts" :min="1" :max="10" size="small" style="width:100px;"></el-input-number>
              <span style="font-size:12px;color:#909399;margin-left:8px;">用户每日最多可尝试认证次数</span>
            </div>
          </div>
        </div>
        <div class="config-footer">
          <el-button @click="resetForm">重置</el-button>
          <el-button v-auth="'business:auditMaterialConfig:save'" type="primary" @click="saveConfig">保存配置</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auditMaterialConfigGetByCountry, auditMaterialConfigSave, auditMaterialConfigCountries, auditMaterialConfigDelete } from '@/api/auditMaterialConfig'
import { countryList } from '@/api/regConfig'
import { thirdPartyConfigListAll } from '@/api/thirdPartyConfig'

const defaultForm = () => ({
  idAuthEnabled: true, idAuthMaxAttempts: 3,
  idTypes: [
    { type: 'idCard', enabled: true, ocrEnabled: true, ocrServiceId: null, factorEnabled: true, factorServiceId: null },
    { type: 'passport', enabled: false, ocrEnabled: false, ocrServiceId: null, factorEnabled: false, factorServiceId: null },
    { type: 'license', enabled: false, ocrEnabled: false, ocrServiceId: null, factorEnabled: false, factorServiceId: null }
  ],
  bankAuthEnabled: true, bankAuthOcrEnabled: false, bankAuthOcrServiceId: null,
  bankAuthFactorEnabled: true, bankAuthFactorServiceId: null, bankAuthMaxAttempts: 5
})

export default {
  name: 'AuditMaterialConfig',
  data() {
    return {
      currentCountry: 'DEFAULT', loading: false,
      allCountries: [], configuredCountries: [], ocrServices: [], factorServices: [],
      form: defaultForm(),
      showCountrySelect: false, addingCountry: null
    }
  },
  computed: {
    availableCountries() {
      return this.allCountries.filter(c => !this.configuredCountries.find(x => x.countryCode === c.countryCode))
    }
  },
  mounted() { this.init() },
  methods: {
    init() {
      this.fetchCountries(); this.fetchServices(); this.fetchConfiguredCountries(); this.loadConfig('DEFAULT')
    },
    fetchCountries() {
      countryList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.allCountries = res.result.list || [] })
    },
    fetchServices() {
      thirdPartyConfigListAll().then(res => {
        if (res.code === 0) { const all = res.result || []; this.factorServices = all.filter(s => s.serviceParentType === 1); this.ocrServices = all.filter(s => s.serviceParentType === 2) }
      })
    },
    fetchConfiguredCountries() {
      auditMaterialConfigCountries().then(res => {
        if (res.code === 0 && res.result) {
          (res.result||[]).forEach(code => { if (code !== 'DEFAULT') { const found = this.allCountries.find(c => c.countryCode === code); if (found) this.configuredCountries.push(found) } })
        }
      })
    },
    switchCountry(code) { this.currentCountry = code; this.loadConfig(code) },
    loadConfig(code) {
      this.loading = true
      auditMaterialConfigGetByCountry(code).then(res => {
        if (res.code === 0 && res.result && res.result !== '{}') {
          try { this.form = Object.assign(defaultForm(), JSON.parse(res.result)) } catch(e) { this.form = defaultForm() }
        } else { this.form = defaultForm() }
      }).finally(() => { this.loading = false })
    },
    openAddCountry() {
      this.showCountrySelect = true; this.addingCountry = null
      this.$nextTick(() => { this.$refs.countrySelectRef && this.$refs.countrySelectRef.focus() })
    },
    cancelAddCountry() { this.showCountrySelect = false; this.addingCountry = null },
    deleteCountry(c) {
      this.$confirm(`确定删除 ${c.countryCode} 的配置吗？`, '提示', { type: 'warning' }).then(() => {
        auditMaterialConfigDelete(c.countryCode).then(() => {
          const idx = this.configuredCountries.findIndex(x => x.countryCode === c.countryCode)
          if (idx >= 0) this.configuredCountries.splice(idx, 1)
          if (this.currentCountry === c.countryCode) { this.currentCountry = 'DEFAULT'; this.loadConfig('DEFAULT') }
          this.$message.success('已删除')
        })
      }).catch(() => {})
    },
    onAddCountrySelect(code) {
      if (!code) return
      const found = this.allCountries.find(c => c.countryCode === code)
      if (found && !this.configuredCountries.find(c => c.countryCode === code)) {
        this.configuredCountries.push({ ...found })
      }
      this.currentCountry = code; this.loadConfig(code)
      this.cancelAddCountry()
    },
    resetForm() { this.$confirm('确定重置当前配置吗？','提示',{type:'warning'}).then(() => { this.form = defaultForm() }) },
    saveConfig() {
      auditMaterialConfigSave({ countryCode: this.currentCountry, configJson: JSON.stringify(this.form) }).then(res => {
        if (res.code === 0) this.$message.success('配置保存成功')
      })
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; background: #f5f7fa; min-height: calc(100vh - 84px); }
.reg-config-layout { display: flex; gap: 16px; min-height: 600px; }
.reg-sidebar { width: 220px; min-width: 220px; background: #fff; border-radius: 4px; padding: 12px; }
.sidebar-add-area { margin-bottom: 10px; }
.select-with-close { display: flex; align-items: center; gap: 4px; }
.close-select-btn { font-size: 16px; color: #909399; cursor: pointer; padding: 4px; border-radius: 2px; }
.close-select-btn:hover { color: #f56c6c; }
.country-list { margin-top: 4px; }
.country-item { display: flex; align-items: center; gap: 6px; padding: 8px 10px; border-radius: 4px; cursor: pointer; font-size: 13px; color: #333; margin-bottom: 2px; }
.country-item:hover { background: #f0f2f5; }
.country-item.active { background: var(--brand-primary-light); color: var(--brand-primary); font-weight: 500; }
.country-icon { font-size: 14px; width: 20px; text-align: center; flex-shrink: 0; }
.country-del { margin-left: auto; color: #c0c4cc; font-size: 16px; cursor: pointer; padding: 0 4px; }
.country-del:hover { color: #f56c6c; }
.reg-content { flex: 1; background: #fff; border-radius: 4px; padding: 20px; min-height: 500px; }
.cfg-card { border: 1px solid #e4e7ed; border-radius: 6px; overflow: hidden; }
.cfg-card-header { display: flex; align-items: center; gap: 8px; padding: 10px 16px; background: #fafafa; font-size: 13px; font-weight: 500; border-bottom: 1px solid #e4e7ed; }
.cfg-card-body { padding: 16px; }
.cfg-row { display: flex; align-items: flex-start; padding: 8px 0; border-bottom: 1px dashed #f0f0f0; }
.cfg-row:last-child { border-bottom: none; }
.cfg-label { width: 120px; min-width: 120px; font-size: 12px; color: #606266; padding-top: 4px; }
.cfg-check-group { display: flex; flex-wrap: wrap; gap: 8px 16px; }
.config-footer { margin-top: 20px; padding-top: 16px; border-top: 1px solid #ebeef5; display: flex; justify-content: flex-end; gap: 8px; }
</style>
